import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class InstitutionMembership extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">Institutional Membership</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead style={{ backgroundColor: "#98002e", color: "white",textAlign:"center" }}>
                      <tr>
                        <th scope="col" style={{width:"10%"}}>SL No</th>
                        <th scope="col" style={{width:"5%"}}>Logo</th>
                        <th scope="col" style={{width:"20%"}}>Institution</th>
                        <th scope="col" style={{width:"15%"}}>URL</th>
                        <th scope="col" style={{width:"50%"}}>Service</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td><img style={{width:"5rem"}} src={process.env.PUBLIC_URL + "/assets/images/digital/IM1.jpg"} alt="logo" /></td>
                        <td>IISc (Indian Institute of Science), Bangalore</td>
                        <td><a target="_blank" href="http://library.iisc.ac.in/">Click Here</a></td>
                        <td>Members are entitled by producing membership card to avail Reference Service and Photocopying facilities are chargeable as per rates prescribed by the Library.
                        The teaching staff members and UG/PG students can retain the IISc entry pass for a maximum period of two days only and return the same, so that the cards can circulate among all the teaching staff members and UG/PG students for their academic and research purpose.</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td><img style={{width:"5rem"}} src={process.env.PUBLIC_URL + "/assets/images/digital/IM2.jpg"} alt="logo" /></td>
                        <td>NAL (National Aerospace Laboratories), Bangalore</td>
                        <td><a target="_blank" href="http://www.icast.org.in">Click Here</a></td>
                        <td>Members are entitled by producing membership card to avail Reference Service, Borrowing (2 Books) and Photocopying facilities are chargeable as per rates prescribed by the Library. The teaching staff members and PG students can make use of facility for their academic and research purpose.</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td><img style={{width:"5rem"}} src={process.env.PUBLIC_URL + "/assets/images/digital/IM3.jpg"} alt="logo" /></td>
                        <td>NDLI (National Digital Library of India)</td>
                        <td><a target="_blank" href="https://ndl.iitkgp.ac.in">Click Here</a></td>
                        <td>Members are entitled to avail Educational materials are available for users ranging from primary to post-graduate levels Repository hosts contents from multiple subject domains like Technology, Science, Humanities, Agriculture and others More than 1,76,07,617 documents are available (including Audios and Videos)</td>
                      </tr>
                      <tr>
                        <td>04</td>
                        <td><img style={{width:"5rem"}} src={process.env.PUBLIC_URL + "/assets/images/digital/IM4.jpg"} alt="logo" /></td>
                        <td>CMTI (Central Manufacturing Technology Institute.)</td>
                        <td><a target="_blank" href="www.cmti-india.net/emti_flash.html">Click Here</a></td>
                        <td>Members are entitled to avail Reference Service and Photocopying facility is available by producing photocopy coupons. CMTI Magazine is also available in the Library.</td>
                      </tr>
                      <tr>
                        <td>05</td>
                        <td><img style={{width:"5rem"}} src={process.env.PUBLIC_URL + "/assets/images/digital/IM5.jpg"} alt="logo" /></td>
                        <td>IIMB (Indian Institute of Management Bangalore) Library</td>
                        <td><a target="_blank" href="http://www.iimb.ac.in/newlibrary">Click Here</a></td>
                        <td>Members are entitled by producing membership card to avail Reference Service, Borrowing (2 Books) and Photocopying facilities are chargeable as per rates prescribed by the Library.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
